import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import {
  bgColor15,
  blackColor,
  blackShade05,
  blackShade19,
  blackShade22,
  blueColor04,
  blueShade10,
  border25,
  deleteBtnColor,
  greenColor16,
  greenColor2,
  greenShade11,
  greenShade12,
  greyColor21,
  greyColor8,
  greyShade85,
  heroSectionText,
  lightBlueColor01,
  lightBlueColor07,
  lightGreen16,
  mobilePrimary,
  orangeBgShade01,
  orangeColor02,
  orangeShade10,
  orangeShade19,
  orderCardBorder,
  orderCardBorder2,
  orderCardBorder3,
  perpleShade10,
  redBgShade01,
  redShade03,
  redShade10,
  voiletShade01,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PersonIcon from "@mui/icons-material/Person";
import PlaceIcon from "@mui/icons-material/Place";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  addThousandsSeparator,
  formatMSToHoursAndMinutes,
  formatShipmentStatus,
} from "../../../utils/helper";
import { textOneLines } from "../../../utils/styles";
import AddIcon from "@mui/icons-material/Add";
import PinDropIcon from "@mui/icons-material/PinDrop";
import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HistoryIcon from "@mui/icons-material/History";
import UpdateIcon from "@mui/icons-material/Update";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import moment from "moment";
import CustomerInstructions from "../Popups/Components/CustomerInstructions";
import { toTitleCase } from "../../../utils/validationUtils";
import {
  togglePendingRowSelect,
  toggleReadyToShipRowSelect,
} from "../../../reducers/orders/ordersSlice";
import { useDispatch } from "react-redux";

function OrderReadyToShipCard({
  id,
  ondcOrderId,
  date,
  username,
  city,
  addressName,
  addressCity,
  orderCost,
  cartCount,
  orderStatus,
  deliveryType,
  statusUpdatedDate,
  handleViewOrder,
  trackingStatus,
  handleTrackOrder,
  type,
  shipmentInfo,
  handleShipmentInfo,
  handleCancelOrder,
  orderType,
  handleResendB2B,
  downloadShipingLabel,
  search,
  handleResend,
  orderData,
  error,
  success,
  getOndcBapNameBySubscriberId,
  index,
  etaPickUpDate,
  etaPickUpTime,
  orderApprovedOn,
  downloadInvoiceAndShipingLabel,
  invoiceDownloadLoader,
  downloadInvoice,
  isSelected,
  orders,
}) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const dispatch = useDispatch();

  const isShowTrackId = () => {
    return (
      orderData?.deliveryType?.type == "delhivery" ||
      orderData?.deliveryType?.type == "business" ||
      orderData?.deliveryType?.type == "delhiveryb2b"
    );
  };

  return (
    <Box sx={styles.card} mt={{ xs: index === 0 ? 2 : 0, md: 0 }}>
      {matches ? (
        <>
          <Box>
            <Grid container columnSpacing={2} rowSpacing={0.1}>
              <Grid item xs={6} md={3}>
                <Box display="flex" alignItems="start" gap={2}>
                  <Checkbox
                    // size="large"
                    sx={styles.checkbox}
                    disabled={deliveryType === "Automated B2B"}
                    checked={isSelected || false}
                    onChange={() => {
                      dispatch(
                        toggleReadyToShipRowSelect({
                          orders,
                          index,
                          isSelected: isSelected,
                        })
                      );
                    }}
                  />
                  <Box
                    display="flex"
                    flexDirection={{ xs: "column", md: "column" }}
                    justifyContent={{ xs: "space-between", md: "flex-start" }}
                  >
                    <Typography
                      fontSize={13}
                      fontWeight={600}
                      color={blackShade05}
                      lineHeight="18px"
                      sx={{ textDecoration: "underline" }}
                    >
                      # {id}
                    </Typography>

                    <Typography
                      variant="p"
                      fontSize={11.5}
                      fontWeight={500}
                      color={bgColor15}
                      lineHeight="20px"
                    >
                      {date}
                    </Typography>

                    <Typography
                      variant="p"
                      fontSize={12}
                      fontWeight={600}
                      color={orderType?.color}
                      lineHeight="18px"
                      mt="2px"
                    >
                      {orderType?.label}{" "}
                      {orderType?.orderType === "ondcOrder" ? (
                        <span style={{ color: blackShade05 }}>
                          {" "}
                          - {getOndcBapNameBySubscriberId()}
                        </span>
                      ) : null}
                    </Typography>

                    {orderType?.orderType === "ondcOrder" && (
                      <Typography
                        variant="p"
                        fontSize={11.5}
                        fontWeight={600}
                        color={orderType?.color}
                        lineHeight="18px"
                        sx={{ ...textOneLines, lineBreak: "anywhere" }}
                      >
                        # {ondcOrderId}
                      </Typography>
                    )}
                  </Box>
                </Box>

                <Stack alignItems="flex-start" mt={1.5}>
                  <DurationInfo
                    lable="Approved In"
                    time={orderApprovedOn || ""}
                    color={blueColor04}
                    bgcolor={lightBlueColor07}
                  />
                </Stack>
              </Grid>

              <Grid item xs={6} md={2.4}>
                <InfoBox
                  titleIcon={<PersonIcon sx={{ fontSize: "17px" }} />}
                  title={
                    username?.toLowerCase()?.trim() === "guest"
                      ? addressName
                      : username
                  }
                  subtitleIcon={
                    <PlaceIcon sx={{ fontSize: "15px", color: bgColor15 }} />
                  }
                  subtitle={addressCity || "N/A"}
                  alignRight
                />
                <Stack flexDirection="row" alignItems="center" gap={3} mt={0.8}>
                  <Box display="flex" gap="10px">
                    <CreditCardIcon sx={{ fontSize: "17px" }} />

                    <Typography
                      variant="h5"
                      fontSize={12.5}
                      fontWeight={600}
                      color={blackShade05}
                      lineHeight="20px"
                      sx={{ ...textOneLines }}
                    >
                      {`₹ ${addThousandsSeparator(orderCost)}`}
                    </Typography>
                  </Box>

                  <Box display="flex" gap="8px">
                    <ShoppingCartIcon sx={{ fontSize: "15px", mt: 0.3 }} />

                    <Typography
                      fontSize={13}
                      fontWeight={500}
                      color={blackShade05}
                      lineHeight="20px"
                    >
                      {cartCount}
                    </Typography>
                  </Box>
                </Stack>

                <Box mt={0.6}>
                  {orderData?.notesConsumer && (
                    <CustomerInstructions
                      customerNotes={orderData?.notesConsumer}
                    />
                  )}
                </Box>
              </Grid>

              <Grid item xs={6} md={2.25}>
                <Stack gap={0.3}>
                  {orderData?.deliveryType?.type == "ondc" ? (
                    <Box sx={{ mb: 0.5, mt: -0.8 }}>
                      <TextWithIcon
                        icon={
                          <Box
                            component="img"
                            src={
                              orderData?.deliveryType?.shipType?.toLowerCase() ==
                              "standard"
                                ? "https://storage.googleapis.com/bodefaults/shopweb/delivery_regular_delivery.svg"
                                : "/./assets/image/bike-delivery.svg"
                            }
                            sx={{ width: "21px" }}
                          />
                        }
                        text={deliveryType}
                      />
                    </Box>
                  ) : (
                    <Typography
                      variant="h5"
                      fontSize={13}
                      fontWeight={600}
                      color={blackShade05}
                      lineHeight="20px"
                      sx={{ ...textOneLines }}
                    >
                      {deliveryType
                        ? deliveryType
                        : !addressCity
                        ? "Store Pickup"
                        : "N/A"}
                    </Typography>
                  )}

                  <Box display="flex" gap="8px" alignItems={"center"}>
                    <AccessTimeIcon
                      sx={{ fontSize: "15px", color: blueColor04 }}
                    />

                    <Typography
                      variant="h5"
                      fontSize={12.5}
                      fontWeight={600}
                      color={blueColor04}
                      lineHeight="20px"
                    >
                      {statusUpdatedDate}
                    </Typography>
                  </Box>

                  {orderData?.shipmentInfo?.shipmentStatus && (
                    <Box
                      sx={{
                        background: perpleShade10,
                        borderRadius: "5px",
                        p: "2px 10px",
                        width: "fit-content",
                        mt: "4px",
                      }}
                    >
                      <Typography
                        variant="h5"
                        fontSize={12}
                        fontWeight={600}
                        color={blackShade05}
                        lineHeight="20px"
                        sx={{
                          ...textOneLines,
                        }}
                      >
                        {formatShipmentStatus(
                          orderData?.shipmentInfo?.shipmentStatus
                        )}
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </Grid>

              <Grid item xs={6} md={2.2}>
                {orderData?.deliveryType?.type == "ondc" ? (
                  orderData?.shipmentInfo?.carrierURL ? (
                    <Stack gap={0.3}>
                      <Box display="flex" alignItems="center" gap={"5px"}>
                        <UpdateIcon
                          sx={{ fontSize: "16px", color: bgColor15 }}
                        />

                        <Typography
                          variant="p"
                          fontSize={12}
                          fontWeight={500}
                          color={bgColor15}
                          lineHeight="17px !important"
                          sx={{ ...textOneLines, mb: -0.1 }}
                        >
                          Estimated Pickup:
                        </Typography>
                      </Box>

                      <Typography
                        variant="p"
                        fontSize={12.5}
                        fontWeight={700}
                        color={greenColor16}
                        lineHeight="15px !important"
                        m="3px 0 -2px 5px !important"
                      >
                        {`${etaPickUpDate ? `${etaPickUpDate}` : "N/A"} 
                      ${
                        etaPickUpDate && etaPickUpTime
                          ? `at ${etaPickUpTime}`
                          : ""
                      }`}
                      </Typography>

                      {orderData?.shipmentInfo?.carrierName && (
                        <TextWithIcon
                          text={orderData?.shipmentInfo?.carrierName}
                        />
                      )}

                      {orderData?.shipmentInfo?.deliveryPersonName && (
                        <TextWithIcon
                          icon={<PersonIcon sx={{ fontSize: "16px" }} />}
                          text={
                            orderData?.shipmentInfo?.deliveryPersonName || "N/A"
                          }
                        />
                      )}
                      {orderData?.shipmentInfo?.deliveryPersonPhone && (
                        <TextWithIcon
                          icon={<LocalPhoneIcon sx={{ fontSize: "16px" }} />}
                          text={
                            orderData?.shipmentInfo?.deliveryPersonPhone ||
                            "N/A"
                          }
                        />
                      )}

                      <Box
                        display="flex"
                        alignItems="center"
                        gap={"5px"}
                        mt={1}
                      >
                        <PinDropOutlinedIcon
                          sx={{ fontSize: "15.5px", color: blueColor04 }}
                        />

                        <Typography
                          variant="p"
                          fontSize={12}
                          fontWeight={500}
                          color={blueColor04}
                          lineHeight="17px !important"
                          sx={{
                            mb: -0.2,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            window.open(
                              orderData?.shipmentInfo?.carrierURL,
                              "_blank"
                            );
                          }}
                        >
                          Click Here
                        </Typography>
                      </Box>
                    </Stack>
                  ) : (
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      color={bgColor15}
                      lineHeight={1.5}
                    >
                      Pickup details will be updated soon
                    </Typography>
                  )
                ) : (
                  <Stack gap={0.3}>
                    <Typography
                      variant="p"
                      fontSize={12}
                      fontWeight={500}
                      color={bgColor15}
                      lineHeight="17px !important"
                    >
                      {isShowTrackId()
                        ? "Tracking ID"
                        : orderData?.deliveryType?.type !== "telyport"
                        ? "Tracking Url"
                        : ""}
                    </Typography>

                    {isShowTrackId() ? (
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={"5px"}
                        mt={0.6}
                      >
                        <AssignmentIndIcon
                          sx={{
                            fontSize: "15.5px",
                            color: isShowTrackId() ? blackColor : blueColor04,
                          }}
                        />

                        <Typography
                          variant="p"
                          fontSize={12}
                          fontWeight={500}
                          color={isShowTrackId() ? blackColor : blueColor04}
                          lineHeight="17px !important"
                          sx={{ mb: -0.2 }}
                        >
                          {orderData?.shipmentInfo?.carrierTrackId || "N/A"}
                        </Typography>
                      </Box>
                    ) : orderData?.deliveryType?.type !== "telyport" ? (
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={"5px"}
                        mt={0.6}
                      >
                        <PinDropOutlinedIcon
                          sx={{ fontSize: "15.5px", color: blueColor04 }}
                        />

                        <Typography
                          variant="p"
                          fontSize={12}
                          fontWeight={500}
                          color={blueColor04}
                          lineHeight="17px !important"
                          sx={{
                            mb: -0.2,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            window.open(
                              orderData?.shipmentInfo?.carrierURL,
                              "_blank"
                            );
                          }}
                        >
                          Click Here
                        </Typography>
                      </Box>
                    ) : (
                      <Typography
                        variant="p"
                        fontSize={12}
                        fontWeight={500}
                        color={blackColor}
                        lineHeight="17px !important"
                        sx={{ mb: -0.2 }}
                      >
                        Ready To Ship
                      </Typography>
                    )}
                  </Stack>
                )}
              </Grid>

              <Grid item xs={12} md={2.15}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent={{ xs: "flex-end", md: "flex-start" }}
                  flexWrap={"wrap"}
                  columnGap={"5px"}
                  rowGap={"10px"}
                >
                  <IconButton
                    sx={styles.actionIconBtn(blueShade10)}
                    disableElevation
                    onClick={handleViewOrder}
                  >
                    <VisibilityIcon sx={{ fontSize: "18px" }} />
                  </IconButton>

                  {shipmentInfo?.carrierTrackId &&
                    type?.toLowerCase() != "business" && (
                      // shipmentInfo?.shipmentStatus != "PACKED" &&
                      <IconButton
                        sx={styles.actionIconBtn(perpleShade10)}
                        disableElevation
                        onClick={handleTrackOrder}
                      >
                        <PinDropIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    )}

                  {orderType?.orderType === "ondcOrder" && (
                    <Button
                      sx={styles.actionBtn(redShade10)}
                      disableElevation
                      onClick={handleCancelOrder}
                    >
                      Cancel
                    </Button>
                  )}

                  {orderData?.deliveryType?.type == "ondc" &&
                    orderData?.invoiceUrl && (
                      <Button
                        sx={styles.actionBtn(orangeShade10)}
                        onClick={() => {
                          downloadInvoice();
                        }}
                        startIcon={
                          invoiceDownloadLoader == orderData?.orderId ? (
                            <CircularProgress size={15} color="inherit" />
                          ) : (
                            <DownloadIcon
                              sx={{ fontSize: "15px !important" }}
                            />
                          )
                        }
                        disabled={invoiceDownloadLoader == orderData?.orderId}
                      >
                        Invoice
                      </Button>
                    )}

                  {(deliveryType === "Automated B2B" ||
                    deliveryType === "Business Delivery" ||
                    deliveryType === "Automated Hyperlocal") && (
                    <Button
                      sx={styles.actionBtn(orangeShade10)}
                      onClick={() => {
                        downloadInvoice();
                      }}
                      startIcon={
                        invoiceDownloadLoader == orderData?.orderId ? (
                          <CircularProgress size={15} color="inherit" />
                        ) : (
                          <DownloadIcon sx={{ fontSize: "15px !important" }} />
                        )
                      }
                      disabled={invoiceDownloadLoader == orderData?.orderId}
                    >
                      Invoice
                    </Button>
                  )}

                  {deliveryType === "Automated Delivery" ? (
                    <>
                      {orderData?.shipmentInfo?.carrierTrackId ? (
                        <Button
                          sx={styles.actionBtn(greenShade11)}
                          onClick={() => {
                            downloadInvoiceAndShipingLabel();
                          }}
                          startIcon={
                            invoiceDownloadLoader == orderData?.orderId ? (
                              <CircularProgress size={15} color="inherit" />
                            ) : (
                              <DownloadIcon
                                sx={{ fontSize: "15px !important" }}
                              />
                            )
                          }
                          disabled={invoiceDownloadLoader == orderData?.orderId}
                        >
                          Invoice & Shipping Label
                        </Button>
                      ) : (
                        <Button
                          sx={styles.actionBtn(orangeShade10)}
                          onClick={() => {
                            downloadInvoice();
                          }}
                          startIcon={
                            invoiceDownloadLoader == orderData?.orderId ? (
                              <CircularProgress size={15} color="inherit" />
                            ) : (
                              <DownloadIcon
                                sx={{ fontSize: "15px !important" }}
                              />
                            )
                          }
                          disabled={invoiceDownloadLoader == orderData?.orderId}
                        >
                          Invoice
                        </Button>
                      )}

                      {/* {orderData?.invoiceUrl && (
                        <Button
                          sx={styles.actionBtn(orangeShade10)}
                          onClick={() => {
                            downloadInvoice();
                          }}
                          startIcon={
                            invoiceDownloadLoader == orderData?.orderId ? (
                              <CircularProgress size={15} color="inherit" />
                            ) : (
                              <DownloadIcon
                                sx={{ fontSize: "15px !important" }}
                              />
                            )
                          }
                          disabled={invoiceDownloadLoader == orderData?.orderId}
                        >
                          Invoice
                        </Button>
                      )} */}
                      {/* <Button
                        sx={styles.actionBtn(greenShade11)}
                        onClick={() => downloadShipingLabel(orderData)}
                        startIcon={
                          <DownloadIcon sx={{ fontSize: "15px !important" }} />
                        }
                      >
                        Shipping Label
                      </Button> */}
                    </>
                  ) : null}

                  {type?.toLowerCase() === "business" &&
                    shipmentInfo?.shipmentStatus == "PACKED" && (
                      <Button
                        sx={styles.actionBtn(greenShade12)}
                        disableElevation
                        onClick={handleShipmentInfo}
                        startIcon={
                          <AddIcon sx={{ fontSize: "15px !important" }} />
                        }
                      >
                        Shipment Info
                      </Button>
                    )}

                  {deliveryType === "Automated B2B" ? (
                    <Button
                      sx={styles.actionBtn(greyShade85)}
                      variant="contained"
                      disableElevation
                      onClick={() => {
                        console.log("hit");
                        if (deliveryType === "Automated Delivery") {
                          console.log("hit1");
                          handleResend(
                            search ? { ...orderData, cartId: id } : orderData
                          );
                        }
                        if (deliveryType === "Automated B2B") {
                          console.log("hit2");
                          handleResendB2B(
                            search ? { ...orderData, cartId: id } : orderData
                          );
                        }
                      }}
                      startIcon={
                        <EmailIcon sx={{ fontSize: "15px !important" }} />
                      }
                    >
                      label
                    </Button>
                  ) : null}

                  {search
                    ? success?.show &&
                      success?.id === orderData?.orderId && (
                        <Typography sx={{ ...styles.msg, color: "green" }}>
                          Shipping label sent successfully
                        </Typography>
                      )
                    : success?.show &&
                      success?.id === orderData?.cartId && (
                        <Typography sx={{ ...styles.msg, color: "green" }}>
                          Shipping label sent successfully
                        </Typography>
                      )}
                  {search
                    ? error?.show &&
                      error?.id === orderData?.orderId && (
                        <Typography
                          sx={{ ...styles.msg, color: deleteBtnColor }}
                        >
                          Shipping Label is not available
                        </Typography>
                      )
                    : error?.show &&
                      error?.id === orderData?.cartId && (
                        <Typography
                          sx={{ ...styles.msg, color: deleteBtnColor }}
                        >
                          Shipping Label is not available
                        </Typography>
                      )}
                  {/* <Button
              sx={styles.cancelBtn}
              variant="contained"
              disableElevation
              onClick={handleCancelOrder}
            >
              Cancel
            </Button> */}
                </Box>

                {orderData?.shipmentInfo?.otpInfo?.otp && (
                  <Typography
                    variant="p"
                    fontSize={12}
                    fontWeight={600}
                    color={blackColor}
                    lineHeight="18px"
                    sx={{ ...textOneLines }}
                    mt={1.5}
                  >
                    Delivery OTP:{"  "}
                    {orderData?.shipmentInfo?.otpInfo?.otp}
                  </Typography>
                )}
                {success?.show && success?.id === orderData?.cartId && (
                  <Typography sx={{ ...styles.msg, color: "green", mt: 1 }}>
                    Shipping label sent successfully
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Box>

          {/* <Box mt={-1}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={5.6}>
                <Stack alignItems="flex-start">
                  <DurationInfo
                    lable="Approved In"
                    time={orderApprovedOn || ""}
                    color={blueColor04}
                    bgcolor={lightBlueColor07}
                  />
                </Stack>
              </Grid>

              <Grid item xs={6} md={5.6}>
                <Stack alignItems="flex-start">
                  <DurationInfo
                    lable="Estimated Pickup"
                    time={`${etaPickUpDate ? `${etaPickUpDate}` : "N/A"} 
                      ${
                        etaPickUpDate && etaPickUpTime
                          ? `at ${etaPickUpTime}`
                          : ""
                      }`}
                    color={greenColor16}
                    bgcolor={lightGreen16}
                  />
                </Stack>
              </Grid>
            </Grid>
          </Box> */}
        </>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Stack borderBottom={border25} pb={1.2}>
              <Box display="flex" justifyContent="space-between" gap="10px">
                <Stack>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color={blackShade05}
                    lineHeight="18px"
                    sx={{ textDecoration: "underline" }}
                  >
                    # {id}
                  </Typography>

                  <Typography
                    variant="p"
                    fontSize={12}
                    fontWeight={500}
                    color={bgColor15}
                    lineHeight="20px"
                  >
                    {date}
                  </Typography>
                </Stack>

                {/* {orderData?.deliveryType?.type != "ondc" && (
                  <Stack>
                    <Typography
                      fontSize={13}
                      fontWeight={600}
                      color={blackShade05}
                      lineHeight="18px"
                    >
                      {deliveryType
                        ? deliveryType
                        : !addressCity
                        ? "Store Pickup"
                        : "N/A"}
                    </Typography>

                    <Typography
                      variant="p"
                      fontSize={12}
                      fontWeight={500}
                      color={bgColor15}
                      textAlign={"end"}
                      lineHeight="20px"
                    >
                      {statusUpdatedDate}
                    </Typography>
                  </Stack>
                )} */}

                <Stack flex={1} alignItems="flex-end">
                  <Box display="flex" alignItems="center" gap={0.4}>
                    <HistoryIcon
                      sx={{ fontSize: "16px", color: blueColor04 }}
                    />

                    <Typography
                      fontSize={12.5}
                      fontWeight={500}
                      color={blueColor04}
                      title={
                        username?.toLowerCase()?.trim() === "guest"
                          ? addressName
                          : username
                      }
                      lineHeight="18px"
                      sx={textOneLines}
                    >
                      Approved In
                    </Typography>
                  </Box>

                  <Typography
                    variant="p"
                    fontSize={12}
                    fontWeight={600}
                    color={blueColor04}
                    lineHeight="20px"
                  >
                    {orderApprovedOn || "N/A"}
                  </Typography>

                  {orderData?.shipmentInfo?.otpInfo?.otp && (
                    <Typography
                      variant="p"
                      fontSize={11.5}
                      fontWeight={600}
                      color={orangeColor02}
                      lineHeight="18px"
                      sx={{ ...textOneLines }}
                    >
                      OTP:{"  "}
                      {orderData?.shipmentInfo?.otpInfo?.otp}
                    </Typography>
                  )}
                </Stack>
              </Box>
              <Typography
                variant="p"
                fontSize={12}
                fontWeight={600}
                color={orderType?.color}
                lineHeight="18px"
                mt="2px"
              >
                {orderType?.label}{" "}
                {orderType?.orderType === "ondcOrder" ? (
                  <span style={{ color: blackShade05 }}>
                    {" "}
                    - {getOndcBapNameBySubscriberId()}
                  </span>
                ) : null}
              </Typography>

              {orderType?.orderType === "ondcOrder" && (
                <Typography
                  variant="p"
                  fontSize={11.5}
                  fontWeight={600}
                  color={orderType?.color}
                  lineHeight="18px"
                  sx={{ ...textOneLines, lineBreak: "anywhere" }}
                >
                  # {ondcOrderId}
                </Typography>
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Box borderBottom={border25} pb={1.2}>
              <Box display="flex" gap={2} mb={0.5}>
                <Stack flex={1}>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color={blackShade05}
                    title={
                      username?.toLowerCase()?.trim() === "guest"
                        ? addressName
                        : username
                    }
                    lineHeight="18px"
                    sx={textOneLines}
                  >
                    {username?.toLowerCase()?.trim() === "guest"
                      ? addressName
                      : username}
                  </Typography>

                  <Typography
                    variant="p"
                    fontSize={12}
                    fontWeight={500}
                    color={bgColor15}
                    lineHeight="20px"
                  >
                    {addressCity || "N/A"}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color={blackShade05}
                    lineHeight="18px"
                  >
                    {`₹ ${addThousandsSeparator(orderCost)}`}
                  </Typography>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-end"
                    gap={1}
                  >
                    <Typography
                      variant="p"
                      fontSize={12}
                      fontWeight={500}
                      color={bgColor15}
                      lineHeight="20px"
                    >
                      Qty
                    </Typography>

                    <Box
                      sx={{ ...styles.legendDot, backgroundColor: bgColor15 }}
                    />
                    <Typography
                      variant="p"
                      fontSize={12}
                      fontWeight={500}
                      color={bgColor15}
                      lineHeight="20px"
                    >
                      {cartCount}
                    </Typography>
                  </Box>
                </Stack>
              </Box>

              {orderData?.notesConsumer && (
                <CustomerInstructions
                  customerNotes={orderData?.notesConsumer}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Stack borderBottom={border25} pb={1.2}>
              <Box display="flex" justifyContent="space-between" gap="10px">
                <Stack alignItems="flex-start">
                  {orderData?.deliveryType?.type != "ondc" ? (
                    <Typography
                      fontSize={13}
                      fontWeight={600}
                      color={blackShade05}
                      lineHeight="18px"
                    >
                      {deliveryType
                        ? deliveryType
                        : !addressCity
                        ? "Store Pickup"
                        : "N/A"}
                    </Typography>
                  ) : (
                    <TextWithIcon
                      icon={
                        <Box
                          component="img"
                          src={
                            orderData?.deliveryType?.shipType?.toLowerCase() ==
                            "standard"
                              ? "https://storage.googleapis.com/bodefaults/shopweb/delivery_regular_delivery.svg"
                              : "/./assets/image/bike-delivery.svg"
                          }
                          sx={{ width: "21px" }}
                        />
                      }
                      text={deliveryType}
                    />
                  )}

                  <Box display="flex" gap="5px" alignItems={"center"} mt={0.4}>
                    <AccessTimeIcon
                      sx={{ fontSize: "16px", color: blueColor04 }}
                    />

                    <Typography
                      variant="h5"
                      fontSize={12}
                      fontWeight={500}
                      color={blueColor04}
                      lineHeight="20px"
                      mb={-0.2}
                    >
                      {statusUpdatedDate}
                    </Typography>
                  </Box>
                </Stack>
                {orderData?.shipmentInfo?.shipmentStatus && (
                  <Box
                    sx={{
                      background: perpleShade10,
                      borderRadius: "5px",
                      p: "2px 10px",
                      width: "fit-content",
                      mt: "4px",
                      height: "24px",
                      display: "inline-block",
                    }}
                  >
                    <Typography
                      variant="h5"
                      fontSize={12}
                      fontWeight={600}
                      color={blackShade05}
                      lineHeight="20px"
                      sx={{
                        ...textOneLines,
                      }}
                    >
                      {formatShipmentStatus(
                        orderData?.shipmentInfo?.shipmentStatus
                      )}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Box borderBottom={border25} pb={1.2}>
              {orderData?.deliveryType?.type == "ondc" ? (
                orderData?.shipmentInfo?.carrierURL ? (
                  <Stack gap={0.3}>
                    <Typography
                      fontSize={12}
                      fontWeight={400}
                      color={bgColor15}
                    >
                      Pickup & Delivery Details
                    </Typography>

                    <Box
                      display="flex"
                      alignItems="center"
                      gap={"5px"}
                      mb={0.8}
                      mt={0.4}
                    >
                      <UpdateIcon sx={{ fontSize: "16px", color: bgColor15 }} />

                      <Typography
                        variant="p"
                        fontSize={12}
                        fontWeight={500}
                        color={bgColor15}
                        lineHeight="17px !important"
                        sx={{ ...textOneLines }}
                      >
                        Estimated Pickup:{" "}
                        <Typography
                          component="span"
                          fontSize={12}
                          fontWeight={700}
                          color={greenColor16}
                          lineHeight="17px !important"
                        >
                          {`${etaPickUpDate ? `${etaPickUpDate}` : "N/A"} 
                      ${
                        etaPickUpDate && etaPickUpTime
                          ? `at ${etaPickUpTime}`
                          : ""
                      }`}
                        </Typography>
                      </Typography>
                    </Box>

                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      {orderData?.shipmentInfo?.deliveryPersonName && (
                        <TextWithIcon
                          icon={<PersonIcon sx={{ fontSize: "16px" }} />}
                          text={
                            orderData?.shipmentInfo?.deliveryPersonName || "N/A"
                          }
                        />
                      )}
                      {orderData?.shipmentInfo?.deliveryPersonPhone && (
                        <TextWithIcon
                          icon={<LocalPhoneIcon sx={{ fontSize: "16px" }} />}
                          text={
                            orderData?.shipmentInfo?.deliveryPersonPhone ||
                            "N/A"
                          }
                        />
                      )}
                    </Box>

                    <Box display="flex" alignItems="center" gap={"5px"} mt={1}>
                      <PinDropOutlinedIcon
                        sx={{ fontSize: "15.5px", color: blueColor04 }}
                      />

                      <Typography
                        variant="p"
                        fontSize={12}
                        fontWeight={500}
                        color={blueColor04}
                        lineHeight="17px !important"
                        sx={{
                          mb: -0.2,
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          window.open(
                            orderData?.shipmentInfo?.carrierURL,
                            "_blank"
                          );
                        }}
                      >
                        Click Here
                      </Typography>
                    </Box>
                  </Stack>
                ) : (
                  <Typography
                    variant="p"
                    fontSize={12}
                    fontWeight={500}
                    color={bgColor15}
                    lineHeight="17px !important"
                  >
                    Pickup details will be updated soon
                  </Typography>
                )
              ) : (
                <Stack gap={0.3}>
                  <Typography
                    variant="p"
                    fontSize={12}
                    fontWeight={500}
                    color={bgColor15}
                    lineHeight="17px !important"
                  >
                    {isShowTrackId()
                      ? "Tracking ID"
                      : orderData?.deliveryType?.type !== "telyport"
                      ? "Tracking Url"
                      : ""}
                  </Typography>

                  {isShowTrackId() ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={"5px"}
                      mt={0.6}
                    >
                      <AssignmentIndIcon
                        sx={{
                          fontSize: "15.5px",
                          color: isShowTrackId() ? blackColor : blueColor04,
                        }}
                      />

                      <Typography
                        variant="p"
                        fontSize={12}
                        fontWeight={500}
                        color={isShowTrackId() ? blackColor : blueColor04}
                        lineHeight="17px !important"
                        sx={{ mb: -0.2 }}
                      >
                        {orderData?.shipmentInfo?.carrierTrackId || "N/A"}
                      </Typography>
                    </Box>
                  ) : orderData?.deliveryType?.type !== "telyport" ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={"5px"}
                      mt={0.6}
                    >
                      <PinDropOutlinedIcon
                        sx={{ fontSize: "15.5px", color: blueColor04 }}
                      />

                      <Typography
                        variant="p"
                        fontSize={12}
                        fontWeight={500}
                        color={blueColor04}
                        lineHeight="17px !important"
                        sx={{
                          mb: -0.2,
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          window.open(
                            orderData?.shipmentInfo?.carrierURL,
                            "_blank"
                          );
                        }}
                      >
                        Click Here
                      </Typography>
                    </Box>
                  ) : (
                    <Typography
                      variant="p"
                      fontSize={12}
                      fontWeight={500}
                      color={bgColor15}
                      lineHeight="17px !important"
                    >
                      Ready To Ship
                    </Typography>
                  )}
                </Stack>
              )}
            </Box>
          </Grid>

          {/* <Grid item xs={12}>
            <Box display="flex" gap={2} borderBottom={border25} pb={1.2}>
              <Stack flex={1}>
                <Typography
                  fontSize={12}
                  fontWeight={600}
                  color={blueColor04}
                  title={
                    username?.toLowerCase()?.trim() === "guest"
                      ? addressName
                      : username
                  }
                  lineHeight="18px"
                  sx={textOneLines}
                >
                  Approved In
                </Typography>

                <Typography
                  variant="p"
                  fontSize={12}
                  fontWeight={500}
                  color={blueColor04}
                  lineHeight="20px"
                >
                  {orderApprovedOn || "N/A"}
                </Typography>
              </Stack>
              <Stack>
                <Typography
                  fontSize={12}
                  fontWeight={600}
                  color={greenColor16}
                  lineHeight="18px"
                  textAlign="right"
                >
                  Estimated Pickup
                </Typography>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-end"
                  gap={1}
                >
                  <Typography
                    variant="p"
                    fontSize={12}
                    fontWeight={500}
                    color={greenColor16}
                    lineHeight="20px"
                  >
                    {`${etaPickUpDate ? `${etaPickUpDate}` : "N/A"} 
                      ${
                        etaPickUpDate && etaPickUpTime
                          ? `at ${etaPickUpTime}`
                          : ""
                      }`}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Grid> */}

          <Grid item xs={12} md={3.1}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent={"flex-end"}
              columnGap={"5px"}
              rowGap={"10px"}
              flexWrap={"wrap"}
            >
              <IconButton
                sx={styles.actionIconBtn(blueShade10)}
                disableElevation
                onClick={handleViewOrder}
              >
                <VisibilityIcon sx={{ fontSize: "18px" }} />
              </IconButton>

              {shipmentInfo?.carrierTrackId &&
                type?.toLowerCase() != "business" && (
                  // shipmentInfo?.shipmentStatus != "PACKED" &&
                  <IconButton
                    sx={styles.actionIconBtn(perpleShade10)}
                    disableElevation
                    onClick={handleTrackOrder}
                  >
                    <PinDropIcon sx={{ fontSize: "18px" }} />
                  </IconButton>
                )}

              {orderType?.orderType === "ondcOrder" && (
                <Button
                  sx={styles.actionBtn(redShade10)}
                  disableElevation
                  onClick={handleCancelOrder}
                >
                  Cancel
                </Button>
              )}

              {orderData?.deliveryType?.type == "ondc" &&
                orderData?.invoiceUrl && (
                  // <a
                  //   href={orderData?.invoiceUrl}
                  //   download
                  //   target="_blank"
                  //   rel="noreferrer"
                  // >
                  <Button
                    sx={styles.actionBtn(orangeShade10)}
                    onClick={() => {
                      downloadInvoice();
                    }}
                    startIcon={
                      invoiceDownloadLoader == orderData?.orderId ? (
                        <CircularProgress size={15} color="inherit" />
                      ) : (
                        <DownloadIcon sx={{ fontSize: "15px !important" }} />
                      )
                    }
                    disabled={invoiceDownloadLoader == orderData?.orderId}
                  >
                    Invoice
                  </Button>
                  // </a>
                )}

              {deliveryType === "Automated Delivery" ? (
                <>
                  {orderData?.invoiceUrl && (
                    <Button
                      sx={styles.actionBtn(orangeShade10)}
                      onClick={() => {
                        downloadInvoice();
                      }}
                      startIcon={
                        invoiceDownloadLoader == orderData?.orderId ? (
                          <CircularProgress size={15} color="inherit" />
                        ) : (
                          <DownloadIcon sx={{ fontSize: "15px !important" }} />
                        )
                      }
                      disabled={invoiceDownloadLoader == orderData?.orderId}
                    >
                      Invoice
                    </Button>
                  )}
                  {/* <Button
                    sx={styles.actionBtn(greenShade11)}
                    onClick={() => downloadShipingLabel(orderData)}
                    startIcon={
                      <DownloadIcon sx={{ fontSize: "15px !important" }} />
                    }
                  >
                    Shipping Label
                  </Button> */}
                </>
              ) : null}

              {type?.toLowerCase() === "business" &&
                shipmentInfo?.shipmentStatus == "PACKED" && (
                  <Button
                    sx={styles.actionBtn(greenShade12)}
                    disableElevation
                    onClick={handleShipmentInfo}
                    startIcon={<AddIcon sx={{ fontSize: "15px !important" }} />}
                  >
                    Shipment Info
                  </Button>
                )}

              {deliveryType === "Automated B2B" ? (
                <Button
                  sx={styles.actionBtn(greyShade85)}
                  variant="contained"
                  disableElevation
                  onClick={() => {
                    console.log("hit");
                    if (deliveryType === "Automated Delivery") {
                      console.log("hit1");
                      handleResend(
                        search ? { ...orderData, cartId: id } : orderData
                      );
                    }
                    if (deliveryType === "Automated B2B") {
                      console.log("hit2");
                      handleResendB2B(
                        search ? { ...orderData, cartId: id } : orderData
                      );
                    }
                  }}
                  startIcon={<EmailIcon sx={{ fontSize: "15px !important" }} />}
                >
                  label
                </Button>
              ) : null}

              {search
                ? success?.show &&
                  success?.id === orderData?.orderId && (
                    <Typography sx={{ ...styles.msg, color: "green" }}>
                      Shipping label sent successfully
                    </Typography>
                  )
                : success?.show &&
                  success?.id === orderData?.cartId && (
                    <Typography sx={{ ...styles.msg, color: "green" }}>
                      Shipping label sent successfully
                    </Typography>
                  )}
              {search
                ? error?.show &&
                  error?.id === orderData?.orderId && (
                    <Typography sx={{ ...styles.msg, color: deleteBtnColor }}>
                      Shipping Label is not available
                    </Typography>
                  )
                : error?.show &&
                  error?.id === orderData?.cartId && (
                    <Typography sx={{ ...styles.msg, color: deleteBtnColor }}>
                      Shipping Label is not available
                    </Typography>
                  )}
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}

export default OrderReadyToShipCard;

const InfoBox = ({ titleIcon, title, subtitleIcon, subtitle, alignRight }) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "column" }}
      justifyContent={{ xs: "space-between", md: "flex-start" }}
      flex={1}
      alignItems={{
        md: "flex-start",
        xs: alignRight ? "flex-end" : "flex-start",
      }}
    >
      <Box
        display="flex"
        // alignItems={{ md: "center", xs: "flex-end" }}
        gap="6px"
      >
        {matches ? titleIcon : null}

        <Typography
          variant="h5"
          fontSize={13}
          fontWeight={600}
          color={blackShade05}
          lineHeight="20px"
          sx={{ ...textOneLines, lineBreak: "anywhere" }}
        >
          {title}
        </Typography>
      </Box>

      <Box
        display="flex"
        alignItems={{ md: "center", xs: "flex-end" }}
        gap="10px"
        flexDirection={{ xs: "column", md: "column" }}
        mt={-0.4}
      >
        <Box
          display="flex"
          alignItems={{ md: "center", xs: "left" }}
          gap={"6px"}
          mt="6px"
        >
          {matches ? subtitleIcon : null}

          <Typography
            variant="p"
            fontSize={12.2}
            fontWeight={500}
            color={bgColor15}
            lineHeight="18px !important"
            ml={{ md: subtitleIcon ? "6px" : "30px ", xs: 0 }}
            sx={{ ...textOneLines }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const TextWithIcon = ({ icon, text, matches }) => {
  return (
    <Box
      display="flex"
      alignItems={{ md: "center", xs: "center" }}
      gap={"6px"}
      mt={{ xs: "0px", md: "6px" }}
    >
      {icon}

      <Typography
        variant="p"
        fontSize={12.5}
        fontWeight={600}
        color={blackColor}
        lineHeight="17px !important"
        sx={{ ...textOneLines, mb: -0.2 }}
      >
        {toTitleCase(text)}
      </Typography>
    </Box>
  );
};

const DurationInfo = ({ lable, time, color, bgcolor }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      bgcolor,
      color,
      p: "3px 8px",
      borderRadius: "6px",
    }}
  >
    <HistoryIcon sx={{ fontSize: "16px" }} />

    <Typography fontSize={12} fontWeight={500} color={color} lineHeight="15px">
      {lable}:{" "}
      <Typography
        component="span"
        fontSize={12.5}
        fontWeight={700}
        color={color}
        lineHeight="15px"
        ml="4px"
      >
        {time}
      </Typography>
    </Typography>
  </Box>
);

const styles = {
  card: {
    display: "flex",
    flexDirection: { xs: "column", md: "column" },
    gap: { xs: "16px", md: "20px" },
    backgroundColor: whiteColor,
    border: { md: orderCardBorder, xs: border25 },
    borderRadius: { md: "0px", xs: "10px" },
    boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    padding: { md: "15px", xs: "12px" },
    mb: { md: 0, xs: 2 },
  },

  dotUi: {
    width: "6px",
    height: "6px",
    borderRadius: "3px",
    backgroundColor: blackShade05,
  },

  addIconBtn: (color) => ({
    padding: { md: "3px 6px", xs: "3px 6px" },
    fontSize: "12px",
    fontWeight: 500,
    color: color || greyColor8,
    backgroundColor: whiteColor,
    border: color ? "1px solid " + color : "1px solid" + greyColor8,
    whiteSpace: "nowrap",
    "&:hover": {
      color: whiteColor,
      backgroundColor: color || greyColor8,
    },
  }),
  viewBtn: (color) => ({
    padding: { md: "3px 6px !important", xs: "3px 6px" },
    fontSize: "12px",
    fontWeight: 600,
    color: color || bgColor15,
    backgroundColor: whiteColor,
    borderRadius: "4px",
    border: color ? "1px solid " + color : "1px solid " + bgColor15,
    "&:hover": {
      color: whiteColor,
      backgroundColor: color || bgColor15,
    },
  }),

  cancelBtn: {
    padding: "3px 24px",
    fontSize: "12px",
    fontWeight: 600,
    color: deleteBtnColor,
    backgroundColor: whiteColor,
    border: "1px solid " + deleteBtnColor,
    "&:hover": {
      color: whiteColor,
      backgroundColor: deleteBtnColor,
    },
  },
  printlabelBtn: {
    padding: "4px 8px",
    fontSize: "12px",
    fontWeight: 600,
    color: whiteColor,
    backgroundColor: blackShade22,
    border: "1px solid " + whiteColor,
    "&:hover": {
      color: blackShade22,
      backgroundColor: whiteColor,
    },
  },

  trackBtn: {
    color: whiteColor,
    backgroundColor: greyColor8,
    "&:hover": {
      color: greyColor8,
      backgroundColor: whiteColor,
    },
  },

  infoTab: {
    display: "flex",
    alignItems: { xs: "flex-start", md: "flex-start" },
    flexDirection: { xs: "column", md: "column" },
    justifyContent: { xs: "space-between", md: "flex-start" },
    pr: { xs: 0, md: 2 },
    // borderRight: { xs: "none", md: orderCardBorder2 },
    // borderBottom: { xs: orderCardBorder2, md: "none" },
    pb: { xs: 1.5, md: 0 },
  },

  downloadBtn: {
    padding: "0",
    fontSize: "12px",
    fontWeight: 600,
    color: blueColor04,
    textDecoration: "underline",
    mt: 1,
    border: "none",
    backgroundColor: whiteColor,
  },

  actionBtn: (color, fontSize) => ({
    padding: "2px 15px",
    fontSize: fontSize || "12px",
    borderRadius: "50px",
    fontWeight: 600,
    color: blackShade19,
    backgroundColor: color,
    border: "1px solid " + color,
    whiteSpace: "nowrap",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: whiteColor,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  }),

  actionIconBtn: (color) => ({
    padding: "4px 10px",
    fontSize: "12px",
    borderRadius: "50px",
    fontWeight: 600,
    color: blackShade19,
    backgroundColor: color,
    border: "1px solid " + color,
    whiteSpace: "nowrap",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: whiteColor,
    },
  }),

  legendDot: {
    width: "4px",
    height: "4px",
    backgroundColor: bgColor15,
    borderRadius: "50%",
  },

  ondcDeliveryStatus: (status) => ({
    fontSize: 11.5,
    fontWeight: 500,
    lineHeight: "15px",
    color: status === "Pending" ? orangeShade19 : redShade03,
    bgcolor: status === "Pending" ? orangeBgShade01 : redBgShade01,
    p: "4.5px 15px",
    borderRadius: "50px",
  }),
  checkbox: {
    color: greyColor21,
    p: 0,
    mt: 0.5,
    // backgroundColor: whiteColor,
    transform: "scale(1.3)",
    "&.Mui-checked": {
      color: blueColor04,
    },
  },
};
